import moment from 'moment';
import { BaseQuery2 } from '@/utils';
import { CALCWEIGHT, GOODSAsCALC, GOODSVOLUME, GOODSWEIGHT } from '@/models/GenerateCondit/Interrelated';

/**
 * 在途
 * @startDate
 * @endDate
 * @scanSite
 * @taskNos
*/
export const IntransitQuery = params => {
  return [
    {
      // 上一站装车,到达后在本站卸车卸车
      simpleGranularity: 'all',
      dataSource: 'actual_load_unload_result',
      dimensions: ['taskNo'],
      startDate: moment(params.startDate).add(-3, 'days').format('YYYY-MM-DD 12:00:00'),
      endDate: params.endDate,
      aggregators: [CALCWEIGHT, GOODSVOLUME],
      andFilters: [
        { key: 'scanType', value: '分拨装车' },
        { key: 'nextSiteCode', value: params.scanSiteCode },
      ],
      inFilters: [
        { key: 'taskNo', value: params.taskNos },
      ]
    },
    {
      // 定时达
      simpleGranularity: 'all',
      dataSource: 'actual_load_unload_result',
      dimensions: ['taskNo'],
      startDate: moment(params.startDate).add(-3, 'days').format('YYYY-MM-DD 12:00:00'),
      endDate: params.endDate,
      aggregators: BaseQuery2(),
      andFilters: [
        { key: 'scanType', value: '分拨装车' },
        { key: 'productType', value: '定时达' },
        { key: 'nextSiteCode', value: params.scanSiteCode },
      ],
      inFilters: [
        { key: 'taskNo', value: params.taskNos },
      ]
    },
    { // 下一站top3
      simpleGranularity: 'all',
      dataSource: 'actual_load_unload_result',
      dimensions: ['taskNo', 'routePath'],
      startDate: moment(params.startDate).add(-3, 'days').format('YYYY-MM-DD 12:00:00'),
      endDate: params.endDate,
      aggregators: BaseQuery2(),
      andFilters: [
        { key: 'scanType', value: '分拨装车' },
        { key: 'nextSiteCode', value: params.scanSiteCode },
      ],
      inFilters: [
        { key: 'taskNo', value: params.taskNos },
      ]
    },
    { // 下一站网点城市的列top3
      simpleGranularity: 'all',
      dataSource: 'actual_load_unload_result',
      dimensions: ['taskNo', 'routePath', 'destinationCity'],
      startDate: moment(params.startDate).add(-3, 'days').format('YYYY-MM-DD 12:00:00'),
      endDate: params.endDate,
      aggregators: BaseQuery2(),
      andFilters: [
        { key: 'scanType', value: '分拨装车' },
        { key: 'nextSiteCode', value: params.scanSiteCode },
      ],
      inFilters: [
        { key: 'taskNo', value: params.taskNos },
      ]
    }
  ]
}

const dataFormat = 'YYYY-MM-DD HH:mm:ss'
/**
 * 在卸
 * @startDate
 * @endDate
 * @scanSite
 * @taskNos  任务号集
*/
export const UnloadedQuery = params => [
  {
    // 装车(上一站的装车数据)
    simpleGranularity: 'all',
    dataSource: 'actual_load_unload_result',
    dimensions: ['taskNo'],
    startDate: moment(params.startDate).add(-3, 'days').format(dataFormat),
    endDate: moment(params.endDate).format(dataFormat),
    aggregators: BaseQuery2(),
    andFilters: [
      { key: 'scanType', value: '分拨装车' },
      { key: 'nextSiteCode', value: params.scanSiteCode },
    ],
    inFilters: [
      { key: 'taskNo', value: params.taskNos },
    ]
  },
  {
    // 定时达
    simpleGranularity: 'all',
    dataSource: 'actual_load_unload_result',
    dimensions: ['taskNo'],
    startDate: moment(params.startDate).add(-3, 'days').format(dataFormat),
    endDate: moment(params.endDate).format(dataFormat),
    aggregators: BaseQuery2(),
    andFilters: [
      { key: 'scanType', value: '分拨装车' },
      { key: 'nextSiteCode', value: params.scanSiteCode },
      { key: 'productType', value: '定时达' },
    ],
    inFilters: [
      { key: 'taskNo', value: params.taskNos },
    ]
  },
  {
    // 下一站top3
    simpleGranularity: 'all',
    dataSource: 'actual_load_unload_result',
    dimensions: ['taskNo', 'routePath'],
    startDate: moment(params.startDate).add(-3, 'days').format(dataFormat),
    endDate: moment(params.endDate).format(dataFormat),
    aggregators: BaseQuery2(),
    andFilters: [
      { key: 'scanType', value: '分拨装车' },
      { key: 'nextSiteCode', value: params.scanSiteCode },
    ],
    inFilters: [
      { key: 'taskNo', value: params.taskNos },
    ]
  },
  {
    // 本站卸车
    simpleGranularity: 'all',
    dataSource: 'actual_load_unload_result',
    dimensions: ['taskNo'],
    startDate: moment(params.startDate).add(-3, 'days').format(dataFormat),
    endDate: moment(params.endDate).add(0, 'days').format(dataFormat),
    aggregators: BaseQuery2(),
    andFilters: [
      { key: 'scanType', value: '分拨卸车' },
      { key: 'scanSiteCode', value: params.scanSiteCode },
    ],
    inFilters: [
      { key: 'taskNo', value: params.taskNos },
    ]
  },
  {
    // 装车(上一站的装车数据, 待交接单)
    simpleGranularity: 'all',
    dataSource: 'actual_load_unload_result',
    dimensions: ['taskNo', 'deliveryReceiptNo'],
    startDate: moment(params.startDate).add(-3, 'days').format(dataFormat),
    endDate: moment(params.endDate).format(dataFormat),
    aggregators: BaseQuery2(),
    andFilters: [
      { key: 'scanType', value: '分拨装车' },
      { key: 'nextSiteCode', value: params.scanSiteCode },
    ],
    inFilters: [
      { key: 'taskNo', value: params.taskNos },
    ]
  },
  {
    //  下一站网点城市的列top3
    simpleGranularity: 'all',
    dataSource: 'actual_load_unload_result',
    dimensions: ['taskNo', 'routePath', 'destinationCity'],
    startDate: moment(params.startDate).add(-3, 'days').format(dataFormat),
    endDate: moment(params.endDate).format(dataFormat),
    aggregators: BaseQuery2(),
    andFilters: [
      { key: 'scanType', value: '分拨装车' },
      { key: 'nextSiteCode', value: params.scanSiteCode },
    ],
    inFilters: [
      { key: 'taskNo', value: params.taskNos },
    ]
  },
   
]
/**
 * 在装 / 未装
 * @startDate
 * @endDate
 * @scanSite
 * @taskNos
 * @nextSites
*/
export const LoadingQuery = params => {
  return [
    { // 0  当前时间内所有装车货量
      remark: '在装-本站已装合计',
      simpleGranularity: 'all',
      dataSource: 'actual_load_unload_result',
      dimensions: ['taskNo', 'deliveryReceiptNo'],
      startDate: moment(params.startDate).add(-3, 'days').format(dataFormat),
      endDate: params.endDate,
      aggregators: [CALCWEIGHT, GOODSVOLUME],
      andFilters: [
        { key: 'scanType', value: '分拨装车' },
        { key: 'scanSiteCode', value: params.scanSiteCode },
      ],
      inFilters: [
        { key: 'taskNo', value: params.taskNos },
      ],
      // boundFilters: [
      //   {
      //     "dimension": "unloadTime",
      //     "lowerValue": params.startDate,
      //     "upperValue": params.endDate,
      //     "lowerEq": false,
      //     "upperEq": false
      //   }
      // ],
    },
    {
      // 1. 装车货量是定时达的
      simpleGranularity: 'all',
      dataSource: 'actual_load_unload_result',
      dimensions: ['taskNo'],
      startDate: moment(params.startDate).add(-3, 'days').format(dataFormat),
      endDate: params.endDate,
      aggregators: BaseQuery2(),
      andFilters: [
        { key: 'scanType', value: '分拨装车' },
        { key: 'productType', value: '定时达' },
        { key: 'scanSiteCode', value: params.scanSiteCode },
      ],
      inFilters: [
        { key: 'taskNo', value: params.taskNos },
      ],
      // boundFilters: [
      //   {
      //     "dimension": "unloadTime",
      //     "lowerValue": params.startDate,
      //     "upperValue": params.endDate,
      //     "lowerEq": false,
      //     "upperEq": false
      //   }
      // ],
    },
    { // 2  当前时间内所有装车货量
      remark: '在装-库存-装车',
      simpleGranularity: 'all',
      dataSource: 'actual_load_unload_result',
      dimensions: ['planNextSite'],
      startDate: moment(params.startDate).add(-3, 'days').format(dataFormat),
      endDate: params.endDate,
      aggregators: BaseQuery2(),
      andFilters: [
        { key: 'scanType', value: '分拨装车' },
        { key: 'scanSiteCode', value: params.scanSiteCode },
      ],
      inFilters: [
        { key: 'planNextSiteCode', value: params.nextSiteCodes },
      ],
      boundFilters: [
        {
          "dimension": "unloadAggregateTime",
          "lowerValue": moment(params.startDate).add(-3, 'days').format('YYYY-MM-DD'),
          "upperValue": moment(params.endDate).format('YYYY-MM-DD'),
          "lowerEq": false,
          "upperEq": false
        }
      ],
    },
    {
      // 3 当前时间内的所有卸车货量
      remark: '在装-库存-卸车',
      simpleGranularity: 'all',
      dataSource: 'actual_load_unload_result',
      dimensions: ['nextSite'],
      startDate: moment(params.startDate).add(-3, 'days').format(dataFormat),
      endDate: params.endDate,
      aggregators: BaseQuery2(),
      andFilters: [
        { key: 'scanType', value: '分拨卸车' },
        { key: 'scanSiteCode', value: params.scanSiteCode },
      ],
      inFilters: [
        { key: 'nextSiteCode', value: params.nextSiteCodes },
      ],
      // unloadTime
    },
    {
      // 4 车辆已装货量, 用于计算装载率
      simpleGranularity: 'all',
      dataSource: 'actual_load_unload_result',
      dimensions: ['taskNo'],
      startDate: moment(params.startDate).add(-3, 'days').format(dataFormat),
      endDate: params.endDate,
      aggregators: [CALCWEIGHT, GOODSWEIGHT],
      andFilters: [
      ],
      inFilters: [
        { key: 'taskNo', value: params.taskNos },
        { key: 'scanType', value: ['分拨装车', '分拨卸车'] },
      ],
      // unloadTime
    },
  ]
}
